import { useEffect, useState } from "react";
import api, { fmtMXN } from "@/lib/api";
import { toast } from "sonner";

export const REGIMENES = [
  ["601", "601 · General de Ley Personas Morales"],
  ["603", "603 · Personas Morales con Fines no Lucrativos"],
  ["605", "605 · Sueldos y Salarios"],
  ["606", "606 · Arrendamiento"],
  ["612", "612 · PF con Actividades Empresariales"],
  ["616", "616 · Sin obligaciones fiscales"],
  ["621", "621 · Incorporación Fiscal"],
  ["626", "626 · RESICO"],
];
const USOS = [
  ["I01", "I01 · Construcciones"],
  ["G03", "G03 · Gastos en general"],
  ["G01", "G01 · Adquisición de mercancías"],
  ["S01", "S01 · Sin efectos fiscales"],
];
const UNIDADES = [["E48", "E48 · Unidad de servicio"], ["ACT", "ACT · Actividad"], ["H87", "H87 · Pieza"], ["MTK", "MTK · Metro cuadrado"], ["LO", "LO · Lote"]];
const FORMAS = [["99", "99 · Por definir"], ["03", "03 · Transferencia"], ["02", "02 · Cheque"], ["01", "01 · Efectivo"]];

export const StampCfdiModal = ({ inv, onClose, onStamped }) => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);
  const [editCustomer, setEditCustomer] = useState(false);
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    api.get("/sat-products").then(({ data }) => setCatalog(data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    let alive = true;
    api.get(`/client-invoices/${inv.id}/stamp-preview`)
      .then(({ data }) => {
        if (!alive) return;
        setData({
          customer: { ...data.customer },
          product: { ...data.product },
          cfdi_use: data.cfdi_use, payment_method: data.payment_method, payment_form: data.payment_form,
          total: data.total, folio: data.folio, has_items: data.has_items,
        });
        const c = data.customer || {};
        const complete = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test((c.rfc || "").toUpperCase()) && /^\d{5}$/.test(c.cp || "") && c.tax_system && c.fiscal_name;
        setEditCustomer(!complete);
      })
      .catch((e) => alive && setErr(e.response?.data?.detail || "Error al cargar datos"));
    return () => { alive = false; };
  }, [inv.id]);

  const setC = (k, v) => setData((d) => ({ ...d, customer: { ...d.customer, [k]: v } }));
  const setP = (k, v) => setData((d) => ({ ...d, product: { ...d.product, [k]: v } }));

  const cpOk = /^\d{5}$/.test(data?.customer?.cp || "");
  const rfcOk = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test((data?.customer?.rfc || "").toUpperCase());
  const descOk = data?.has_items || (data?.product?.description || "").trim().length > 0;
  const ready = data && rfcOk && cpOk && data.customer.tax_system && data.customer.fiscal_name && descOk;

  const uploadXmlAlt = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setSaving(true);
    try {
      const { data: out } = await api.post(`/client-invoices/${inv.id}/cfdi-xml`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`XML timbrado cargado · UUID …${(out.uuid_cfdi || "").slice(-8)}`);
      onStamped();
    } catch (e2) { toast.error(e2.response?.data?.detail || "Error al cargar el XML"); }
    setSaving(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!ready) return;
    setSaving(true);
    try {
      const { data: out } = await api.post(`/client-invoices/${inv.id}/stamp`, {
        customer: {
          fiscal_name: data.customer.fiscal_name, rfc: data.customer.rfc,
          tax_system: data.customer.tax_system, cp: data.customer.cp, email: data.customer.email,
        },
        product: data.product,
        cfdi_use: data.cfdi_use, payment_method: data.payment_method, payment_form: data.payment_form,
      });
      toast.success(`Timbrada · UUID ${out.uuid_cfdi || "pendiente"}${out.cfdi_test_mode ? " (MODO TEST)" : ""}`);
      onStamped();
    } catch (e2) { toast.error(e2.response?.data?.detail || "Error al timbrar"); }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(5,8,18,0.85)", backdropFilter: "blur(6px)" }} onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="w-full max-w-2xl panel-strong max-h-[92vh] overflow-y-auto p-5 space-y-3" data-testid="stamp-cfdi-modal">
        <div className="label-mono">// TIMBRAR {inv.folio} ANTE EL SAT · {fmtMXN(inv.total)}</div>
        {err && <div className="text-sm" style={{ color: "#fca5a5" }}>{err}</div>}
        {!data && !err && <div className="text-sm text-slate-400">Cargando…</div>}
        {data && (
          <>
            <div className="label-mono pt-1">// 1 · CLIENTE (como su Constancia de Situación Fiscal)</div>
            <div className="text-[11px] text-slate-500">{data.customer.name}</div>
            {!editCustomer ? (
              <div className="panel px-3 py-2 flex items-start gap-3" data-testid="stamp-customer-review" style={{ border: "1px solid #16a34a55" }}>
                <div className="flex-1 text-xs space-y-0.5">
                  <div className="text-slate-100 font-bold">{data.customer.fiscal_name}</div>
                  <div className="font-mono text-slate-300">RFC {data.customer.rfc} · C.P. {data.customer.cp}</div>
                  <div className="text-slate-400">{(REGIMENES.find(([v]) => v === data.customer.tax_system) || [null, data.customer.tax_system])[1]}</div>
                  {data.customer.email && <div className="text-slate-500">{data.customer.email}</div>}
                  <div className="text-[10px]" style={{ color: "#86efac" }}>✓ Datos de facturación tomados del catálogo de Clientes</div>
                </div>
                <button type="button" onClick={() => setEditCustomer(true)} data-testid="stamp-edit-customer" className="btn-ghost px-2 py-1 text-[10px] uppercase tracking-widest">Editar</button>
              </div>
            ) : (
            <div className="grid grid-cols-2 gap-2">
              <div className="col-span-2"><label className="label-mono block mb-1">Razón social fiscal *</label>
                <input className="input-cyber px-3 py-2 text-sm w-full uppercase" value={data.customer.fiscal_name || ""} onChange={(e) => setC("fiscal_name", e.target.value.toUpperCase())} data-testid="stamp-fiscal-name" placeholder="SIN RÉGIMEN SOCIETARIO (S.A. DE C.V.)" /></div>
              <div><label className="label-mono block mb-1">RFC *</label>
                <input className="input-cyber px-3 py-2 text-sm w-full font-mono uppercase" value={data.customer.rfc || ""} onChange={(e) => setC("rfc", e.target.value.toUpperCase().trim())} data-testid="stamp-rfc" style={!rfcOk && data.customer.rfc ? { borderColor: "#dc2626" } : {}} /></div>
              <div><label className="label-mono block mb-1">C.P. fiscal *</label>
                <input className="input-cyber px-3 py-2 text-sm w-full font-mono" value={data.customer.cp || ""} onChange={(e) => setC("cp", e.target.value.replace(/\D/g, "").slice(0, 5))} data-testid="stamp-cp" style={!cpOk && data.customer.cp ? { borderColor: "#dc2626" } : {}} /></div>
              <div><label className="label-mono block mb-1">Régimen fiscal *</label>
                <select className="input-cyber px-2 py-2 text-sm w-full" value={data.customer.tax_system || ""} onChange={(e) => setC("tax_system", e.target.value)} data-testid="stamp-tax-system">
                  <option value="" style={{ background: "#0a0f1d" }}>— Selecciona —</option>
                  {REGIMENES.map(([v, l]) => <option key={v} value={v} style={{ background: "#0a0f1d" }}>{l}</option>)}
                </select></div>
              <div><label className="label-mono block mb-1">Correo (opcional)</label>
                <input className="input-cyber px-3 py-2 text-sm w-full" value={data.customer.email || ""} onChange={(e) => setC("email", e.target.value)} data-testid="stamp-email" /></div>
            </div>
            )}
            {!data.has_items && (
              <>
                <div className="label-mono pt-2">// 2 · PRODUCTO / SERVICIO SAT (la obra)</div>
                {catalog.length > 0 && (
                  <select className="input-cyber px-2 py-2 text-xs w-full" value="" data-testid="stamp-catalog-select"
                    onChange={(e) => {
                      const p = catalog.find((x) => x.id === e.target.value);
                      if (p) setData((d) => ({ ...d, product: { ...d.product, product_key: p.product_key, unit_key: p.unit_key } }));
                    }}>
                    <option value="" style={{ background: "#0a0f1d" }}>— Usar claves de un producto del catálogo (Productos SAT) —</option>
                    {catalog.map((p) => <option key={p.id} value={p.id} style={{ background: "#0a0f1d" }}>{p.description.slice(0, 70)} · {p.product_key}</option>)}
                  </select>
                )}
                <div><label className="label-mono block mb-1">Descripción del concepto *</label>
                  <textarea rows={2} className="input-cyber px-3 py-2 text-sm w-full" value={data.product.description || ""} onChange={(e) => setP("description", e.target.value)} data-testid="stamp-description" /></div>
                <div className="grid grid-cols-2 gap-2">
                  <div><label className="label-mono block mb-1">Clave producto/servicio SAT</label>
                    <input className="input-cyber px-3 py-2 text-sm w-full font-mono" value={data.product.product_key || ""} onChange={(e) => setP("product_key", e.target.value.replace(/\D/g, ""))} data-testid="stamp-product-key" />
                    <div className="text-[10px] text-slate-500 mt-0.5">72111000 Construcción de edificios · 72101500 Mantenimiento</div></div>
                  <div><label className="label-mono block mb-1">Clave unidad</label>
                    <select className="input-cyber px-2 py-2 text-sm w-full" value={data.product.unit_key || "E48"} onChange={(e) => setP("unit_key", e.target.value)} data-testid="stamp-unit-key">
                      {UNIDADES.map(([v, l]) => <option key={v} value={v} style={{ background: "#0a0f1d" }}>{l}</option>)}
                    </select></div>
                </div>
              </>
            )}
            <div className="label-mono pt-2">// 3 · CFDI</div>
            <div className="grid grid-cols-3 gap-2">
              <div><label className="label-mono block mb-1">Uso CFDI</label>
                <select className="input-cyber px-2 py-2 text-sm w-full" value={data.cfdi_use} onChange={(e) => setData({ ...data, cfdi_use: e.target.value })} data-testid="stamp-cfdi-use">
                  {USOS.map(([v, l]) => <option key={v} value={v} style={{ background: "#0a0f1d" }}>{l}</option>)}
                </select></div>
              <div><label className="label-mono block mb-1">Método de pago</label>
                <select className="input-cyber px-2 py-2 text-sm w-full" value={data.payment_method} onChange={(e) => setData({ ...data, payment_method: e.target.value })} data-testid="stamp-payment-method">
                  <option value="PPD" style={{ background: "#0a0f1d" }}>PPD · Diferido</option>
                  <option value="PUE" style={{ background: "#0a0f1d" }}>PUE · Una exhibición</option>
                </select></div>
              <div><label className="label-mono block mb-1">Forma de pago</label>
                <select className="input-cyber px-2 py-2 text-sm w-full" value={data.payment_form} onChange={(e) => setData({ ...data, payment_form: e.target.value })} data-testid="stamp-payment-form">
                  {FORMAS.map(([v, l]) => <option key={v} value={v} style={{ background: "#0a0f1d" }}>{l}</option>)}
                </select></div>
            </div>
            {!ready && <div className="text-[11px]" style={{ color: "#f59e0b" }}>Captura razón social fiscal, RFC válido, C.P. de 5 dígitos y régimen fiscal tal como la Constancia del cliente.</div>}
          </>
        )}
        <div className="flex items-center justify-between gap-2 pt-2" style={{ borderTop: "1px solid var(--border)" }}>
          <label className="btn-ghost px-3 py-2 text-[10px] uppercase tracking-widest cursor-pointer" data-testid="stamp-upload-xml-alt"
            style={{ color: "#86efac", border: "1px solid #16a34a" }} title="Si timbraste con tu PAC (ClickFactura), sube aquí el XML y se extraen UUID y sellos">
            ¿Timbraste en ClickFactura? Sube el XML
            <input type="file" accept=".xml,text/xml" className="hidden" onChange={(e) => uploadXmlAlt(e.target.files[0])} />
          </label>
          <div className="flex gap-2">
            <button type="button" onClick={onClose} className="btn-ghost px-4 py-2 text-xs uppercase tracking-widest">Cancelar</button>
            <button type="submit" disabled={!ready || saving} data-testid="stamp-submit-btn" className="btn-primary px-5 py-2 text-xs uppercase tracking-widest disabled:opacity-50">{saving ? "Timbrando…" : "⚡ Timbrar"}</button>
          </div>
        </div>
      </form>
    </div>
  );
};
